export function GET_API_TOKEN() {
  return window.sessionStorage.getItem('bearerToken')
}

export function SET_API_TOKEN(token: string) {
  sessionStorage.setItem('bearerToken', token)
}


// export const API_BASE_URL = 'https://anidra.online/anidranewUI'
// export const ECG_SOCKET_URL = 'https://ecglive.anidrak.com/'
// export const ECG_API_BASE_URL = 'https://anidra.online/anidranewUI'
// export const ECG_ARRHYTHMIA_API_BASE_URL = 'https://ecg.anidrak.com/'
// export const SOCKET_URL = 'https://www.anidrak.com'

export const API_BASE_URL         = 'https://demoanidra.com';
export const ECG_SOCKET_URL      = 'https://ecglive.anidraprodk.com/';
export const ECG_API_BASE_URL  = 'https://demoanidra.com';
export const ECG_ARRHYTHMIA_API_BASE_URL = 'https://ecg.anidraprodk.com/'
export const SOCKET_URL           = 'https://www.demoanidraa.com';
